import styled from 'styled-components';

const ContentWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 16px;
  border-top: 1px #c9cfd7 solid;
  width: 100%;
`;
const SvgHeaderBlockStyled = styled(ContentWrapperStyled)`
  padding: 0px;
  border-top: none;
  > svg {
    margin-bottom: 45px;
  }
`;

const TextBlockRowStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

const TextBlockStyled = styled.div`
  border: 1px solid #c9cfd7;
  width: 100%;
  height: 196px;
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  color: #494c66;
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  > p {
    text-align: center;
    strong {
      font-weight: 600;
    }
  }
  @media (min-width: 769px) {
    width: 48%;
  }
`;

const ButtonStyled = styled.button`
  cursor: pointer;
  outline: none;
  margin-bottom: 10px;
  border-radius: 40px;
  width: 224px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: cerapro;
  font-size: 14px;
  line-height: 18px;
  color: #0e141d;
  font-weight: 400;
  position: relative;
  background: #ffffff;
  border: #4d008c 2px solid;
  > span {
    margin: 0px 5px;
    font-weight: 600;
  }

  svg {
    margin-right: 5px;
  }
`;

const ButtonDisabledStyled = styled(ButtonStyled)`
  pointer-events: none;
  cursor: default;
  color: #fff;
  > svg {
    > path {
      fill: #fff;
    }
  }
  &:after {
    background-color: #dcdcdc;
  }
  &:before {
    background: #cacaca;
  }
`;

export {
  ContentWrapperStyled,
  SvgHeaderBlockStyled,
  TextBlockStyled,
  ButtonStyled,
  ButtonDisabledStyled,
  TextBlockRowStyled,
};
